import request from '../utils/request'
const serviceName = 'processapprovalnew';

//获取质检表单套表列表
export function getQualityTempListFile(data) {
  return request({
    url: `/${serviceName}/qualityDataTemp/getQualityTempListFile`,
    method: 'post',
    data
  })
}

//获取质检表单列表
export function getQualityListFile(data) {
  return request({
    url: `/${serviceName}/qualityDataTemp/getQualityListFile`,
    method: 'post',
    data
  })
}

//质检资料数据
export function getQualityDatumListApi(data) {
  return request({
    url: `/${serviceName}/qualityDataTemp/getQualityDatumList`,
    method: 'post',
    data
  })
}

export function search (formId) {
  return request({
    url: '/fs/files/search?metaData.formId='+formId,
    method: 'post'
  })
}

//树节点上下移
export function changeSn(data) {
  return request({
    url: `/${serviceName}/qualityDataTemp/changeSn`,
    method: 'post',
    data
  })
}

//树节点上下移
export function changeSnEnd(data) {
  return request({
    url: `/${serviceName}/qualityDataTemp/changeSnEnd`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/processApproval.js